import type { VideoReference } from "@/data/video-search-content";

export function addWorkspaceVideo(target: URL, video?: VideoReference) {
  if (!video?.url) return;
  try {
    const url = new URL(video.url);
    if (!["https:", "http:"].includes(url.protocol) || url.username || url.password || url.href.length > 2048) return;
    target.searchParams.set("workspace_video", url.href);
    if (video.title) target.searchParams.set("workspace_video_name", video.title.slice(0, 240));
  } catch { /* Invalid source links must not block workspace navigation. */ }
}
